import React from "react";
import styled from "styled-components";

import Card from "./Card";
import CartItem from "./CartItem";
import Empty from "./Empty";

const CartSummary = (props: any) => {
  const { className, cartItems } = props;
  return (
    <Card title={"Bag"} color={"#FFF"}>
      <Wrapper className={className}>
        {cartItems.length > 0 ? (
          cartItems.map((item: any) => {
            return <CartItem key={item.id} className={"item"} {...item} />;
          })
        ) : (
          <Empty />
        )}
      </Wrapper>
    </Card>
  );
};

const Wrapper = styled.div`
  .item {
    margin: 40px 0;
  }

  .item:first-of-type {
    margin-top: 0;
  }

  .item:last-of-type {
    margin-bottom: 0;
  }
`;

export default CartSummary;
